var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarSharingbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1258 1070.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .carSharing_before_svg__cls-3{fill:#343a50}.carSharing_before_svg__cls-24,.carSharing_before_svg__cls-32,.carSharing_before_svg__cls-34,.carSharing_before_svg__cls-6{fill:#fff}.carSharing_before_svg__cls-6{opacity:.32}.carSharing_before_svg__cls-7{fill:#eb9a6b}.carSharing_before_svg__cls-16,.carSharing_before_svg__cls-23,.carSharing_before_svg__cls-26,.carSharing_before_svg__cls-27,.carSharing_before_svg__cls-28,.carSharing_before_svg__cls-29,.carSharing_before_svg__cls-30,.carSharing_before_svg__cls-31,.carSharing_before_svg__cls-33,.carSharing_before_svg__cls-34,.carSharing_before_svg__cls-35,.carSharing_before_svg__cls-36,.carSharing_before_svg__cls-37,.carSharing_before_svg__cls-38{stroke:#343a50}.carSharing_before_svg__cls-16,.carSharing_before_svg__cls-23,.carSharing_before_svg__cls-27,.carSharing_before_svg__cls-28,.carSharing_before_svg__cls-30,.carSharing_before_svg__cls-31,.carSharing_before_svg__cls-33,.carSharing_before_svg__cls-34,.carSharing_before_svg__cls-35,.carSharing_before_svg__cls-36,.carSharing_before_svg__cls-37,.carSharing_before_svg__cls-38{stroke-miterlimit:10}.carSharing_before_svg__cls-16{stroke-width:2px}.carSharing_before_svg__cls-26,.carSharing_before_svg__cls-29{stroke-linejoin:round;stroke-linecap:round}.carSharing_before_svg__cls-27,.carSharing_before_svg__cls-28,.carSharing_before_svg__cls-30,.carSharing_before_svg__cls-31,.carSharing_before_svg__cls-33,.carSharing_before_svg__cls-34,.carSharing_before_svg__cls-35,.carSharing_before_svg__cls-36{stroke-width:3.15px}.carSharing_before_svg__cls-16{fill:#89bb21}.carSharing_before_svg__cls-14,.carSharing_before_svg__cls-17{mix-blend-mode:multiply}.carSharing_before_svg__cls-15,.carSharing_before_svg__cls-17{fill:#dedede}.carSharing_before_svg__cls-18{fill:#6b472d}.carSharing_before_svg__cls-23{fill:#065494;stroke-width:3px}.carSharing_before_svg__cls-24{font-size:91.55px;font-family:Lato-Regular,Lato}.carSharing_before_svg__cls-26{fill:#cca605}.carSharing_before_svg__cls-26,.carSharing_before_svg__cls-29{stroke-width:2px}.carSharing_before_svg__cls-27{fill:#525254}.carSharing_before_svg__cls-28{fill:#404040}.carSharing_before_svg__cls-29{fill:#f0c100}.carSharing_before_svg__cls-30{fill:none}.carSharing_before_svg__cls-31{fill:#a8a9ad}.carSharing_before_svg__cls-32{opacity:.17}.carSharing_before_svg__cls-33{fill:#ef6767}.carSharing_before_svg__cls-35{fill:#a81628}.carSharing_before_svg__cls-36{fill:#ce2232}.carSharing_before_svg__cls-37,.carSharing_before_svg__cls-38{fill:#303042;stroke-width:3.24px}.carSharing_before_svg__cls-38{fill:#353454}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Free-Floating_Vorher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Boden"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "-.99 1071.8 -.99 994.86 -.97 795.65 1258.99 795.65 1258.99 1071.8 -.99 1071.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 796.64v274.17H0V796.64h1258m2-2H-1.95v278.15H1260V794.66z",
    className: "carSharing_before_svg__cls-3"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5d1d6",
    points: "1258 444.3 .02 444.07 0 -9.19 1257.98 -9.19 1258 444.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a9bf5c",
    points: "-1 797.63 -.99 430.8 1257.72 430.8 1259 797.63 -1 797.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.72 431.8l1.28 364.84H0V431.8h1256.72m2-2H-2v368.84h1262v-2l-1.28-364.84v-2z",
    className: "carSharing_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Wolken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M775.11 108c10.22-24 36.06-41.16 66.58-41.16 30.14 0 55.8 16.71 66.27 40.27a54.63 54.63 0 0113.49-1.86c27.53 0 49.85 19.9 49.85 44.44s-22.3 44.49-49.85 44.49H791.84c-27.54 0-49.85-19.9-49.85-44.45.01-19.28 13.86-35.54 33.12-41.73zM234.59 68.87c6.08-14.3 21.47-24.51 39.64-24.51 17.94 0 33.22 10 39.45 24a32.55 32.55 0 018-1.11c16.4 0 29.68 11.85 29.68 26.46s-13.28 26.46-29.68 26.46h-77.13c-16.4 0-29.68-11.84-29.68-26.46 0-11.5 8.25-21.18 19.72-24.84zM560.7 93.53c-6.62-15.53-23.35-26.65-43.11-26.65-19.51 0-36.13 10.82-42.9 26.07a35.79 35.79 0 00-8.74-1.2c-17.82 0-32.27 12.88-32.27 28.77s14.45 28.77 32.27 28.77h83.91c17.83 0 32.28-12.88 32.28-28.77 0-12.52-8.98-23.01-21.44-26.99zM1073.31 31.73c5.74-13.5 20.26-23.13 37.41-23.13 16.94 0 31.36 9.39 37.24 22.62a30.88 30.88 0 017.58-1c15.48 0 28 11.18 28 25s-12.54 25-28 25h-72.83c-15.47 0-28-11.18-28-25-.01-10.9 7.78-20.04 18.6-23.49z",
    className: "carSharing_before_svg__cls-6"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: ".99 548.53 -1.01 170.83 458.49 170.23 458.49 548.53 .99 548.53",
    className: "carSharing_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.49 171.23v376.3H2l-2-375.7 457.49-.6m2-2l-461.5.6 2 379.7h459.5v-380.3z",
    className: "carSharing_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 316.6,
    height: 378.3,
    x: 141.89,
    y: 170.23,
    fill: "#cc825c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.49 171.23v376.3h-314.6v-376.3h314.6m2-2h-318.6v380.3h318.6v-380.3z",
    className: "carSharing_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 175.34,
    height: 285.34,
    x: 250.51,
    y: 199.93,
    fill: "#7fc3ca",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "rotate(-180 338.18 342.6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.86 485.31 328.86 351.48 250.5 351.48 250.5 332.83 328.86 332.83 328.86 199.91 347.51 199.91 347.51 332.83 425.87 332.83 425.87 351.48 347.51 351.48 347.51 485.31 328.86 485.31",
    className: "carSharing_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.52 200.91v132.92h78.35v16.65h-78.35v133.84h-16.67V350.48h-78.36v-16.65h78.36V200.91h16.67m2-2h-20.66v132.93h-78.35v20.63h78.35V486.3h20.65V352.47h78.35v-20.63h-78.35V198.92z",
    className: "carSharing_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#823838",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "-.9 23.38 458.77 169.23 -.9 169.55 -.9 23.38"
  }), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Haus",
    stroke: "#343a50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.8,
    height: 513.52,
    x: 1199.27,
    y: 158.65,
    fill: "#d9d9d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b3b3b",
    strokeMiterlimit: 10,
    strokeWidth: 3.15,
    points: "1259.67 110.86 1259.67 66.86 1258 69.18 1199.04 159.01 1259.67 158.64 1259.67 110.86"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#89bb21",
    d: "M485 652.7h-2.29c-13.7 0-24.84-7.21-24.84-16.06 0-7.05 7-13.15 17.11-15.26a12.25 12.25 0 01-3.77-8.53c0-7.13 7.08-13.27 17.44-15.32a10.61 10.61 0 01-.34-2.6c0-7.77 8.3-14.25 19.92-15.73 1-8.27 11.71-14.81 24.76-14.81a37.75 37.75 0 016.42.54c4.64-4.24 12.13-6.74 20.26-6.74a35.67 35.67 0 0112.9 2.31c4.22-3.66 10.79-6 17.9-6.38 4.62-4.37 12.22-7 20.5-7 13.38 0 24 6.51 24.79 15 8.12 1.37 14.68 5.37 17.27 10.52 11.61.09 21.33 5.22 23.85 12.42 11.5.26 21 5.46 23.35 12.68 9.79 2.29 16.3 8.27 16.3 15.08 0 3.62-1.78 7-5.09 9.79 7.76 2.8 12.62 8.09 12.62 14 0 7.34-7.65 13.72-18.6 15.53h-.13l-219.13.5c-.37.05-.77.06-1.2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 548.69c12.85 0 23.26 6.48 23.26 14.48v.31c8.77 1.13 15.71 5.35 17.81 10.74h.68c11.72 0 21.39 5.4 23 12.42h.25c11.74 0 21.42 5.42 23 12.46 9.28 1.9 16 7.33 16 13.74 0 4.07-2.7 7.74-7 10.37 8.53 2.14 14.56 7.34 14.56 13.42 0 6.71-7.34 12.33-17.28 14l-219.07.5a10.92 10.92 0 01-1.13 0h-2.29c-12.85 0-23.26-6.48-23.26-14.48 0-7.12 8.26-13 19.14-14.24-3.6-2.55-5.8-5.88-5.8-9.55 0-6.86 7.67-12.59 17.95-14.08a9.5 9.5 0 01-.85-3.84c0-7.28 8.63-13.28 19.85-14.31v-.17c0-8 10.41-14.48 23.26-14.48a36.88 36.88 0 016.93.65c4.1-4.11 11.4-6.86 19.75-6.86a33.73 33.73 0 0113.23 2.58c3.89-3.81 10.57-6.4 18.25-6.67 4.09-4.16 11.42-6.94 19.82-6.94m0-3.15c-8.42 0-16.21 2.6-21.15 7-6.94.45-13.17 2.64-17.56 6.12a37.79 37.79 0 00-12.59-2.09c-8.19 0-15.79 2.46-20.74 6.64a40.23 40.23 0 00-5.94-.43c-13.46 0-24.27 6.39-26.13 15-11.81 1.88-20.12 8.82-20.12 17.13a13.1 13.1 0 00.08 1.39c-10.28 2.5-17.18 9-17.18 16.53a13.11 13.11 0 002.52 7.61c-9.47 2.72-15.86 9-15.86 16.18 0 9.89 11.6 17.63 26.41 17.63h3.56l218.94-.5h.51c11.72-1.94 19.91-9 19.91-17.09 0-6-4.3-11.32-11.35-14.54a13.55 13.55 0 003.83-9.25c0-7.36-6.63-13.8-16.68-16.41-2.89-7.18-12.21-12.34-23.47-12.89-3.16-7.08-12.66-12.09-24-12.44-2.93-5-9.08-8.77-16.83-10.31-1.7-8.7-12.59-15.22-26.18-15.22z",
    className: "carSharing_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "carSharing_before_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.85 643.32c0-7.12 8.26-13 19.14-14.24-3.6-2.55-5.8-5.88-5.8-9.54 0-6.86 7.67-12.59 17.95-14.09a9.5 9.5 0 01-.85-3.84c0-7.28 8.63-13.28 19.85-14.31v-.17c0-8 10.41-14.48 23.26-14.48a36.88 36.88 0 016.93.65c4.1-4.11 11.4-6.85 19.75-6.85A33.73 33.73 0 01583.3 569c3.89-3.81 10.57-6.39 18.25-6.67 4.09-4.15 11.42-6.94 19.82-6.94a35.16 35.16 0 0110.7 1.63c-3.71-4.93-11.73-8.35-21.06-8.35-8.4 0-15.73 2.78-19.82 6.94-7.68.27-14.36 2.86-18.26 6.67a33.64 33.64 0 00-13.22-2.58c-8.35 0-15.65 2.75-19.75 6.86a36.88 36.88 0 00-6.93-.65c-12.85 0-23.26 6.48-23.26 14.48v.17c-11.22 1-19.85 7-19.85 14.31a9.5 9.5 0 00.85 3.84c-10.28 1.49-17.95 7.22-17.95 14.08 0 3.67 2.2 7 5.8 9.55-10.88 1.21-19.14 7.12-19.14 14.24 0 5.6 5.1 10.44 12.57 12.85a10.08 10.08 0 01-2.2-6.11z",
    className: "carSharing_before_svg__cls-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Baum"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1196.05,
    cy: 339.39,
    className: "carSharing_before_svg__cls-16",
    rx: 114.24,
    ry: 115.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.66 341.59c0-63.59 51.15-115.14 114.24-115.14q3.91 0 7.77.27a113.48 113.48 0 00-23.62-2.47c-63.09 0-114.24 51.55-114.24 115.14 0 60.95 47 110.84 106.47 114.86-51.76-10.96-90.62-57.25-90.62-112.66z",
    className: "carSharing_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.82 676.37a5.53 5.53 0 01-4-1.7 5.26 5.26 0 01-1.47-3.94l18.23-267.8-20.7-20.93a1.65 1.65 0 01-.36-1.83 1.67 1.67 0 011.54-1.05 1.59 1.59 0 01.74.18l19.75 9.63 2.73-40.17.17-3.18a5.24 5.24 0 0110.45-.19l1.84 25.25 19.59-10.45h.15a2.9 2.9 0 01.58-.05 3.05 3.05 0 012.91 2.12 3.09 3.09 0 01-1.06 3.48l-20.42 14.86 18.33 290a5.39 5.39 0 01-1.39 4.05 5.52 5.52 0 01-4.06 1.77z",
    className: "carSharing_before_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.69 341.59a4.1 4.1 0 014.22 3.89l1.95 26.77 20.8-11.09h.4a2.13 2.13 0 011.24 3.81l-20.84 15.17 18.36 290.51a4.41 4.41 0 01-4.45 4.75h-43.55a4.41 4.41 0 01-4.46-4.59l18.26-268.23-21-21.25a.69.69 0 01.47-1.17.66.66 0 01.3.07l21.08 10.29 2.84-41.65.16-3.2a4.12 4.12 0 014.25-4.05m0-2a6.11 6.11 0 00-6.24 6l-.17 3.2-2.63 38.65-18.41-9a2.56 2.56 0 00-1.18-.28 2.68 2.68 0 00-1.89 4.58l20.4 20.6-18.21 267.33a6.3 6.3 0 001.74 4.72 6.54 6.54 0 004.72 2h43.55a6.52 6.52 0 004.8-2.1 6.32 6.32 0 001.64-4.83l-18.28-289.36 20-14.52a4.13 4.13 0 00-2.46-7.4 4.74 4.74 0 00-.75.06l-.31.06-.28.15-18.13 9.52-1.73-23.7a6.08 6.08 0 00-6.21-5.75z",
    className: "carSharing_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "carSharing_before_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1209 374.46l22.86-12.19a2 2 0 00-2.22-1.11l-20.8 11.09zM1199.62 392.52l3-43.68.17-3.2a4.08 4.08 0 012.09-3.51 4.26 4.26 0 00-6.4 3.51l-.16 3.2-2.82 41.65zM1180.66 670.78l18.27-268.23-19.84-20-4.72-2.31a.68.68 0 00-.78 1.1l21 21.25-18.26 268.23a4.41 4.41 0 004.46 4.59h4.3a4.42 4.42 0 01-4.43-4.63z",
    className: "carSharing_before_svg__cls-15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Baum-2",
    "data-name": "Baum"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 556.72,
    cy: 290.12,
    className: "carSharing_before_svg__cls-16",
    rx: 54.29,
    ry: 54.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 291.16c0-30.22 24.31-54.72 54.29-54.72 1.25 0 2.48 0 3.7.13a54 54 0 00-11.23-1.18c-30 0-54.29 24.5-54.29 54.73A54.53 54.53 0 00553 344.71a54.64 54.64 0 01-43-53.55z",
    className: "carSharing_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.48 450.8a3.11 3.11 0 01-2.27-1 3 3 0 01-.85-2.26l8.66-127-9.68-9.78a1.32 1.32 0 01.93-2.26 1.3 1.3 0 01.58.14l8.69 4.23 1.24-18.31.08-1.5a3 3 0 016-.11l.82 11.2 8.66-4.62h.53a2 2 0 011.87 1.36 2 2 0 01-.68 2.24L564.6 310l8.69 137.53a3 3 0 01-.79 2.31 3.17 3.17 0 01-2.32 1z",
    className: "carSharing_before_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.88 291.16a1.94 1.94 0 012 1.85l.93 12.73 9.89-5.28h.19a1 1 0 01.58 1.81l-9.9 7.21 8.73 138.07a2.1 2.1 0 01-2.12 2.26h-20.7a2.1 2.1 0 01-2.12-2.18l8.64-127.5-10-10.09a.33.33 0 01.22-.56.28.28 0 01.15 0l10 4.88 1.35-19.79.08-1.52a2 2 0 012-1.93m0-2a4 4 0 00-4 3.83l-.08 1.51-1.14 16.8-7.35-3.58a2.25 2.25 0 00-1-.24 2.33 2.33 0 00-1.65 4l9.42 9.46-8.62 126.58a4.1 4.1 0 001.11 3 4.14 4.14 0 003 1.28h20.7a4.13 4.13 0 003.06-1.34 4.07 4.07 0 001-3.09L565.6 310.4l9-6.56a3 3 0 00-1.76-5.43 2.47 2.47 0 00-.54.05l-.32.05-.28.15-7.17 3.83-.7-9.66a4 4 0 00-4-3.71z",
    className: "carSharing_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "carSharing_before_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.89 306.79l10.86-5.8a1 1 0 00-1-.53l-9.89 5.28zM558.42 315.37l1.41-20.76.08-1.52a1.94 1.94 0 011-1.67 2 2 0 00-3 1.67l-.08 1.52-1.34 19.79zM549.41 447.62l8.68-127.49-9.43-9.52-2.24-1.09a.32.32 0 00-.37.52l10 10.09-8.68 127.49a2.1 2.1 0 002.12 2.18h2a2.1 2.1 0 01-2.08-2.18z",
    className: "carSharing_before_svg__cls-15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Baum-3",
    "data-name": "Baum"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 954.66,
    cy: 303.95,
    className: "carSharing_before_svg__cls-16",
    rx: 63.28,
    ry: 63.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.16 305.17c0-35.22 28.33-63.78 63.28-63.78 1.45 0 2.88.05 4.31.15a63.46 63.46 0 00-13.09-1.37c-34.95 0-63.28 28.56-63.28 63.78 0 33.77 26 61.4 59 63.63a63.68 63.68 0 01-50.22-62.41z",
    className: "carSharing_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.23 491.07a3.56 3.56 0 01-2.54-1.08 3.38 3.38 0 01-.93-2.52l10.08-148.15-11.33-11.44a1.38 1.38 0 011-2.36 1.43 1.43 0 01.61.14l10.34 5 1.47-21.59.09-1.75a3.29 3.29 0 013.35-3.2 3.26 3.26 0 013.33 3.07l1 13.31 10.3-5.44h.16a2.58 2.58 0 01.39 0 2.19 2.19 0 011.3 3.91L963.68 327l10.13 160.38a3.41 3.41 0 01-.88 2.57 3.5 3.5 0 01-2.58 1.13z",
    className: "carSharing_before_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.34 305.17a2.27 2.27 0 012.34 2.16l1.08 14.83 11.52-6.16h.22a1.18 1.18 0 01.69 2.12l-11.54 8.4 10.16 160.92a2.44 2.44 0 01-2.46 2.64h-24.13a2.45 2.45 0 01-2.47-2.55l10.12-148.58-11.65-11.77a.38.38 0 01.26-.65.35.35 0 01.17 0l11.68 5.7 1.57-23.07.09-1.77a2.28 2.28 0 012.35-2.25m0-2a4.25 4.25 0 00-4.35 4.14l-.09 1.78-1.37 20.07-9-4.39a2.29 2.29 0 00-1-.25 2.38 2.38 0 00-1.68 4.06l11 11.12-10.09 147.72a4.39 4.39 0 001.21 3.28 4.49 4.49 0 003.25 1.4h24.13a4.47 4.47 0 003.31-1.46 4.41 4.41 0 001.15-3.35l-10.1-159.78 10.65-7.76a3.18 3.18 0 00-1.86-5.72 2.76 2.76 0 00-.57.06l-.31.05-.28.15-8.81 4.7-.86-11.76a4.28 4.28 0 00-4.33-4z",
    className: "carSharing_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "carSharing_before_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M961.85 323.38l12.66-6.75a1.13 1.13 0 00-1.23-.62l-11.52 6.15zM956.64 333.38l1.64-24.19.09-1.77a2.27 2.27 0 011.16-1.95 2.35 2.35 0 00-3.54 1.95l-.09 1.77-1.57 23.07zM946.14 487.52l10.12-148.58-11-11.1-2.62-1.28a.38.38 0 00-.43.61l11.65 11.77-10.11 148.58a2.45 2.45 0 002.48 2.55h2.38a2.45 2.45 0 01-2.47-2.55z",
    className: "carSharing_before_svg__cls-15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Fasade",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2ab80",
    points: "-.99 727.75 77.43 727.75 77.43 255.08 -.99 255.62 -.99 727.75"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.42,
    height: 132.91,
    x: -0.99,
    y: 594.84,
    fill: "#ca9072"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a04a48",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "-.9 178.33 107.85 261.67 -.99 261.67 -.9 178.33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Schilder"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.41,
    height: 229.7,
    x: 841.03,
    y: 576.92,
    fill: "#828282",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 4.68
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.6,
    height: 138.94,
    x: 796.94,
    y: 469.4,
    className: "carSharing_before_svg__cls-23",
    rx: 20.59
  }), /*#__PURE__*/React.createElement("text", {
    className: "carSharing_before_svg__cls-24",
    transform: "matrix(1.04 0 0 1 818.36 568.94)"
  }, "\r\n      P\r\n     "), /*#__PURE__*/React.createElement("rect", {
    width: 92.6,
    height: 138.94,
    x: 1223.78,
    y: 469.4,
    className: "carSharing_before_svg__cls-23",
    rx: 20.59
  }), /*#__PURE__*/React.createElement("text", {
    className: "carSharing_before_svg__cls-24",
    transform: "matrix(1.04 0 0 1 1244.88 568.98)"
  }, "\r\n      P\r\n     "), /*#__PURE__*/React.createElement("rect", {
    width: 4.41,
    height: 234.11,
    x: 414.2,
    y: 577.63,
    fill: "#828282",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 4.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.6,
    height: 138.94,
    x: 370.11,
    y: 469.4,
    className: "carSharing_before_svg__cls-23",
    rx: 20.59
  }), /*#__PURE__*/React.createElement("text", {
    className: "carSharing_before_svg__cls-24",
    transform: "matrix(1.04 0 0 1 391.12 568.86)"
  }, "\r\n      P\r\n     "), /*#__PURE__*/React.createElement("rect", {
    width: 92.6,
    height: 138.94,
    x: -57.22,
    y: 469.4,
    className: "carSharing_before_svg__cls-23",
    rx: 20.59
  }), /*#__PURE__*/React.createElement("text", {
    className: "carSharing_before_svg__cls-24",
    transform: "matrix(1.04 0 0 1 -36.21 568.86)"
  }, "\r\n      P\r\n     ")), /*#__PURE__*/React.createElement("path", {
    d: "M1319.8 718.39l30.59-14.78-25.48-24c-.54.26-37.09-7-37.62-6.77a23.52 23.52 0 00-3.62 2.14l-90.67-2.13-9.3 3.37c-.71-.35-2.12 2.15-2.83 1.81-.54-.26-.37 2.6-.91 2.34l-27.85 26.22 31.92 16.09c7.74-11.26 17.58-19 39.32-17.08h44.46c23.9.27 43.06 5.72 51.99 12.79z",
    className: "carSharing_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.75 704.1h-53c-29.52 0-53.45 16.84-53.45 37.61l-26.78 4.69h216.51l-29.87-4.69c.04-20.77-23.89-37.61-53.41-37.61zm47.39 36.81h-147.62v-.72c0-18.4 21.19-33.32 47.34-33.32h52.94c26.15 0 47.34 14.92 47.34 33.32z",
    className: "carSharing_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.99,
    height: 21.06,
    x: 1209.3,
    y: 732.71,
    className: "carSharing_before_svg__cls-27",
    transform: "rotate(-29.97 1211.52 743.306)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.06,
    height: 3.99,
    x: 1218.22,
    y: 741.25,
    className: "carSharing_before_svg__cls-27",
    transform: "rotate(-60.02 1228.787 743.24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.61 786.49a30.14 30.14 0 1130.14-30.14 30.17 30.17 0 01-30.14 30.14zm0-54.3a24.16 24.16 0 1024.16 24.16 24.19 24.19 0 00-24.16-24.16z",
    className: "carSharing_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.58,
    height: 40.94,
    x: 1092.44,
    y: 883.16,
    className: "carSharing_before_svg__cls-28",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.71 741.46c-2.3-4.11-5.71-6.07-8.6-7.69 0 0-9.43-5.27-27.83-1.81a4.94 4.94 0 00-2.49 1.13c-2.64 2.41-1.35 7.69-1.13 8.6 1.52 6.2 6.56 9.84 10.18 12.44a36.43 36.43 0 0010.64 5.21c3 .89 5.7 1.7 9.27 1.35 2.26-.22 8-.78 10.86-5.2 3.63-5.6-.26-12.88-.9-14.03z",
    className: "carSharing_before_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.68 754.53c0-3.76-53.77-6.8-120.09-6.8s-120.09 3-120.09 6.8l-46.2 27 333.33.67z",
    className: "carSharing_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.08 784.43c-12.58-8.94-84.74-15.8-171.88-15.8-92 0-167.32 7.65-173.43 17.32a18.14 18.14 0 00-8 15.07v46.32h.06c2.38 9 83 16.22 182 16.22s179.62-7.22 182-16.22h.06V801a18.14 18.14 0 00-10.81-16.57z",
    className: "carSharing_before_svg__cls-29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1250.76,
    x2: 1250.75,
    y1: 698.73,
    y2: 711.27,
    className: "carSharing_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.94 847.85a8 8 0 00-3.07-6.27v5.76h-.06c-2.38 9-83 16.22-182 16.22s-179.63-7.22-182-16.22h-.06v-5.73a8 8 0 00-3 6.24v27.83a7.89 7.89 0 00.24 1.89 2.34 2.34 0 00-.24 1c0 11 82.88 19.84 185.12 19.84s185.11-8.88 185.11-19.84a2.34 2.34 0 00-.24-1 7.89 7.89 0 00.24-1.89z",
    className: "carSharing_before_svg__cls-31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.52,
    height: 9.19,
    x: 1233.49,
    y: 706.67,
    className: "carSharing_before_svg__cls-27",
    rx: 3.38
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1140.62 748.63 1368.23 751.99 1361.94 713.52 1338.72 688.36 1319.5 675.46 1274.87 672.14 1187.94 676.64 1165.65 691.75 1146.33 719.37 1140.62 748.63",
    className: "carSharing_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.83 669.18h-78.19a78.9 78.9 0 00-78.9 78.9v5.13h236v-5.13a78.89 78.89 0 00-78.91-78.9zm70 77.22h-217.97v-1.51a69.89 69.89 0 0169.89-69.89h78.15a69.89 69.89 0 0169.89 69.89z",
    className: "carSharing_before_svg__cls-29"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.55,
    height: 24.57,
    x: 1077.18,
    y: 792.84,
    className: "carSharing_before_svg__cls-33",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104.27,
    height: 25.49,
    x: 1202.29,
    y: 826.26,
    className: "carSharing_before_svg__cls-34",
    rx: 9.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.37 714.42L930 699.64l-25.48-24c-.53.26-37.08-7-37.62-6.77a25.42 25.42 0 00-3.62 2.14l-90.62-2.15-9.31 3.37c-.7-.35-2.12 2.15-2.83 1.81-.53-.26-.37 2.6-.9 2.34l-27.86 26.22 31.92 16.09c7.75-11.26 17.59-19 39.32-17.08h44.46c23.82.29 42.98 5.74 51.91 12.81z",
    className: "carSharing_before_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.32 700.13h-53c-29.51 0-53.44 16.84-53.44 37.61l-26.79 4.69h216.54l-29.87-4.69c0-20.74-23.92-37.61-53.44-37.61zm47.39 36.81H758.08v-.72c0-18.4 21.2-33.32 47.35-33.32h52.94c26.14 0 47.34 14.92 47.34 33.32z",
    className: "carSharing_before_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.99,
    height: 21.06,
    x: 788.86,
    y: 728.74,
    className: "carSharing_before_svg__cls-27",
    transform: "rotate(-29.97 791.016 739.349)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.06,
    height: 3.99,
    x: 797.79,
    y: 737.28,
    className: "carSharing_before_svg__cls-27",
    transform: "rotate(-60.02 808.342 739.281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.18 782.52a30.14 30.14 0 1130.14-30.14 30.17 30.17 0 01-30.14 30.14zm0-54.3a24.16 24.16 0 1024.15 24.16 24.18 24.18 0 00-24.15-24.16z",
    className: "carSharing_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.58,
    height: 40.94,
    x: 672.01,
    y: 879.19,
    className: "carSharing_before_svg__cls-28",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.58,
    height: 40.94,
    x: 939.25,
    y: 879.19,
    className: "carSharing_before_svg__cls-28",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.27 737.49c-2.3-4.11-5.71-6.07-8.59-7.69 0 0-9.43-5.27-27.83-1.81a4.94 4.94 0 00-2.49 1.13c-2.64 2.41-1.35 7.69-1.13 8.6 1.51 6.2 6.56 9.84 10.18 12.44a36.19 36.19 0 0010.59 5.21c3 .89 5.7 1.7 9.28 1.35 2.26-.22 8-.78 10.86-5.2 3.67-5.6-.22-12.87-.87-14.03zM947.28 739.44c2.3-4.11 5.71-6.08 8.6-7.69 0 0 9.43-5.27 27.83-1.81a4.86 4.86 0 012.49 1.13c2.64 2.41 1.35 7.69 1.13 8.6-1.52 6.2-6.57 9.83-10.18 12.44a36.23 36.23 0 01-10.64 5.2c-3 .89-5.7 1.71-9.27 1.36-2.27-.22-8-.78-10.86-5.2-3.63-5.6.26-12.88.9-14.03z",
    className: "carSharing_before_svg__cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.24 750.56c0-3.76-53.76-6.8-120.09-6.8s-120.08 3-120.08 6.8l-46.2 27 333.32.67z",
    className: "carSharing_before_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.65 780.46c-12.59-8.94-84.75-15.8-171.89-15.8-92 0-167.31 7.65-173.42 17.32a18.12 18.12 0 00-8 15.07v46.32h.05c2.39 9 83 16.22 182 16.22s179.63-7.22 182-16.22h.06v-46.32a18.16 18.16 0 00-10.8-16.59z",
    className: "carSharing_before_svg__cls-36"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 830.33,
    x2: 830.32,
    y1: 694.76,
    y2: 707.3,
    className: "carSharing_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.5 843.88a8 8 0 00-3.06-6.27v5.76h-.06c-2.38 9-83 16.22-182 16.22s-179.62-7.22-182-16.22h-.05v-5.73a8 8 0 00-3 6.24v27.83a7.89 7.89 0 00.23 1.89 2.51 2.51 0 00-.23 1c0 11 82.87 19.84 185.11 19.84s185.11-8.88 185.11-19.84a2.51 2.51 0 00-.23-1 7.89 7.89 0 00.23-1.89z",
    className: "carSharing_before_svg__cls-31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.52,
    height: 9.19,
    x: 813.05,
    y: 702.7,
    className: "carSharing_before_svg__cls-27",
    rx: 3.38
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "715.95 743.29 943.56 746.65 937.27 708.18 914.04 683.02 894.83 670.12 850.19 666.81 763.27 671.3 740.98 686.41 721.66 714.03 715.95 743.29",
    className: "carSharing_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.4 665.21h-78.19a78.89 78.89 0 00-78.9 78.9v5.13h236v-5.13a78.9 78.9 0 00-78.91-78.9zm70 77.22H724.42v-1.51A69.89 69.89 0 01794.31 671h78.16a69.89 69.89 0 0169.89 69.89z",
    className: "carSharing_before_svg__cls-36"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.55,
    height: 24.57,
    x: 656.74,
    y: 788.87,
    className: "carSharing_before_svg__cls-33",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.55,
    height: 24.57,
    x: 963.26,
    y: 788.55,
    className: "carSharing_before_svg__cls-33",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104.27,
    height: 25.49,
    x: 780.63,
    y: 822.29,
    className: "carSharing_before_svg__cls-34",
    rx: 9.93
  }), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_before_svg__Auto_links"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.52 711.87l30.59-14.79-25.48-24c-.54.26-37.09-7-37.62-6.76a24.33 24.33 0 00-3.62 2.13l-90.63-2.14-9.3 3.36c-.71-.34-2.13 2.15-2.83 1.81-.54-.26-.37 2.61-.91 2.35l-27.86 26.21 31.92 16.09c7.75-11.26 17.59-19 39.33-17.07H.57c23.86.28 43.02 5.73 51.95 12.81z",
    className: "carSharing_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.47 697.57h-53c-29.52 0-53.45 16.84-53.45 37.62l-26.78 4.68H94.79l-29.87-4.68c0-20.78-23.92-37.62-53.45-37.62zm47.39 36.81H-88.76v-.72c0-18.4 21.19-33.32 47.34-33.32h52.94c26.15 0 47.34 14.92 47.34 33.32z",
    className: "carSharing_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.58,
    height: 40.94,
    x: 92.4,
    y: 876.63,
    className: "carSharing_before_svg__cls-28",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.44 736.88c2.3-4.11 5.7-6.07 8.59-7.69 0 0 9.43-5.27 27.83-1.81a4.94 4.94 0 012.49 1.13c2.64 2.41 1.35 7.69 1.13 8.6-1.51 6.2-6.56 9.84-10.18 12.44a36.08 36.08 0 01-10.63 5.21c-3 .89-5.7 1.71-9.28 1.35-2.26-.22-8-.78-10.86-5.2-3.63-5.6.26-12.91.91-14.03z",
    className: "carSharing_before_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.39 748c0-3.75-53.76-6.8-120.08-6.8s-120.09 3-120.09 6.8l-49.44 31.42 338.86-2.76z",
    className: "carSharing_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.8 777.9c-12.58-8.9-84.74-15.79-171.88-15.79-92 0-167.32 7.64-173.43 17.31a18.15 18.15 0 00-8 15.07v46.33h.06c2.38 9 82.95 16.22 182 16.22s179.63-7.23 182-16.22h.06v-46.33a18.15 18.15 0 00-10.81-16.59z",
    className: "carSharing_before_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.66 841.33a8 8 0 00-3.07-6.27v5.76h-.06c-2.38 9-82.95 16.22-182 16.22s-179.62-7.23-182-16.22h-.06v-5.73a8 8 0 00-3 6.24v27.82a7.91 7.91 0 00.24 1.9 2.3 2.3 0 00-.24 1c0 11 82.88 19.83 185.11 19.83s185.08-8.88 185.08-19.82a2.3 2.3 0 00-.24-1 7.91 7.91 0 00.24-1.9z",
    className: "carSharing_before_svg__cls-31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.52,
    height: 9.19,
    x: -33.79,
    y: 700.15,
    className: "carSharing_before_svg__cls-27",
    rx: 3.38
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-129.61 742.59 97.58 743.38 91.72 707.48 68.49 682.32 49.27 669.42 4.63 666.11 -82.28 670.61 -104.58 685.71 -123.9 713.33 -129.61 742.59",
    className: "carSharing_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.55 662.65h-78.19a78.91 78.91 0 00-78.9 78.9v5.14h236v-5.14a78.9 78.9 0 00-78.91-78.9zm70 77.22h-217.97v-1.51a69.89 69.89 0 0169.89-69.89h78.15a69.89 69.89 0 0169.89 69.89z",
    className: "carSharing_before_svg__cls-38"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.55,
    height: 24.57,
    x: 116.41,
    y: 785.99,
    className: "carSharing_before_svg__cls-33",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104.27,
    height: 25.49,
    x: -67.09,
    y: 819.73,
    className: "carSharing_before_svg__cls-34",
    rx: 9.93
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSharingbefore);
export default __webpack_public_path__ + "static/media/carSharing.before.f8e08fc0.svg";
export { ForwardRef as ReactComponent };